import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutModule, SharedModule } from '@app/shared';
import { MaterialModule } from '@app/shared/material.module';
import { AuthenticationGuard as AuthGuard } from '@app/shared/services/authguards';
import { DistrictAddEditComponent } from './add-edit-list/district-add-edit.component';
import { DistrictListComponent } from './add-edit-list/district-list.component';

const routes: Routes = [
  { path: '', component: DistrictListComponent, canActivate: [AuthGuard], data: { title: 'District' } }
];
@NgModule({
  declarations: [DistrictListComponent, DistrictAddEditComponent],
  imports: [
    RouterModule.forChild(routes),
    LayoutModule,
    MaterialModule,
    SharedModule,
  ],
  entryComponents: [DistrictAddEditComponent]
})
export class DistrictModule { }